import { css } from "@digits-css"
import colors from "@digits-shared/themes/colors"

export const GLASS_LAYER = css`
  background: ${colors.translucentWhite40};
  border: 1px solid ${colors.translucentWhite40};
  background-blend-mode: luminosity;
  backdrop-filter: blur(8px);
`

/**
 * Renders the Figma "Glass Stroke" gradient as a 1px border using a ::before pseudo-element.
 * The parent must set `position: relative` and `border-radius` (both inherited by ::before).
 * Pairs with `border: 1px solid transparent` on the parent to reserve layout space.
 */
export const GLASS_STROKE_BORDER = css`
  border: 1px solid transparent;
  box-sizing: content-box;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    padding: 1px;
    border-radius: inherit;
    pointer-events: none;
    background: linear-gradient(
      149deg,
      ${colors.translucentWhite70} 4.33%,
      ${colors.transparent} 34.44%,
      ${colors.transparent} 46.96%,
      ${colors.translucentWhite40} 78.54%
    );
    mask:
      linear-gradient(white 0, white 0) content-box,
      linear-gradient(white 0, white 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
`
